import React from "react";
import usePaginatedItems, { makeSampleLoader } from "./usePaginatedItems";
import useIsNarrow from "../commons/useIsNarrow";

// Convenience hook that couples the responsive perPage (1 on narrow,
// configurable on wide) with a paginated loader.
//
// The loader argument can be either:
//   - a sync array (sample data) — auto-wrapped with makeSampleLoader
//   - an async `(page, perPage) => { items, totalCount }` function
//
// Returns everything the section needs to hand to <PagedCarousel>.
export default function usePagedSection({
  sampleItems,
  loader,
  widePerPage = 4,
}) {
  const isNarrow = useIsNarrow();
  const perPage = isNarrow ? 1 : widePerPage;

  // When consumer passes sampleItems, build (and memoize) a sample loader.
  // When consumer passes an async loader, use it as-is.
  const resolvedLoader = React.useMemo(() => {
    if (loader) return loader;
    if (sampleItems) return makeSampleLoader(sampleItems);
    return async () => ({ items: [], totalCount: 0 });
  }, [loader, sampleItems]);

  const result = usePaginatedItems({ loader: resolvedLoader, perPage });

  return { ...result, perPage, isNarrow };
}
